import React, { useState } from 'react';
import { CButton, CSpinner } from '@coreui/react';
import { toast } from 'react-toastify';
import config from '../utils/EnvironmentSwitcher';
const StripeBuyButton = ({ nft, authUser }) => {
      const [loading, setLoading] = useState(false);

      const handleBuyClick = async () => {
            setLoading(true);
            try {
                  // Create a checkout session
                  const response = await fetch(`${config.paymentUrl}/create-checkout-session`, {
                        method: 'POST',
                        headers: {
                              'Content-Type': 'application/json',
                              'Authorization': `Bearer ${authUser.authUser.accessToken}`,
                        },
                        body: JSON.stringify({
                              nftId: nft.id,
                              title: nft.title,
                              price: nft.price,
                              description: nft.description,
                              imageUrl: nft.imageUrl,
                              sellerID: nft.sellerID,
                              buyerID: authUser.authUser.uid,
                        }),
                  });

                  if (!response.ok) {
                        throw new Error('Failed to create checkout session');
                  }

                  const { url } = await response.json();

                  // Redirect to Stripe Checkout
                  window.location.href = url;

            } catch (error) {
                  console.error('Error creating checkout session:', error);
                  toast.error('Failed to initiate checkout');
            } finally {
                  setLoading(false);
            }
      };

      return (
            <CButton
                  color="success"
                  onClick={handleBuyClick}
                  disabled={loading}
            >
                  {loading ? (
                        <>
                              <CSpinner size="sm" className="me-2" />
                              Processing...
                        </>
                  ) : (
                        'Buy Physical NFT'
                  )}
            </CButton>
      );
};

export default StripeBuyButton;